<template>
  <v-layout column>
    <v-flex>
      <h4 class="lighten-3 mb-2">{{categoryData.name}}</h4>
    </v-flex>
    <v-flex><span v-html=""></span></v-flex>
    <input-component
      v-for="input in orderInputs"
      :selectedInputs="selectedInputs"
      :inputData="input"
      :slug="slug"
      :key="input.id"
      @emit-data="handleEmittedData"
    >
    </input-component>
  </v-layout>
</template>

<script>
  import InputComponent from '~/components/anfragen/wizards/input/InputComponent'

  export default {
    name: "CategoryComponent",
    components: {
      InputComponent
    },
    data() {
      return {
        formData: {},
      }
    },
    props: {
      categoryData: {
        type: Object,
        required: true,
      },
      selectedInputs: {
        type: Array,
        required: false,
      },
      slug: {
        type: String,
        required: true,
      },
    },
    computed: {
      orderInputs: function () {
        if ('inputs' in this.categoryData)
          this.categoryData.inputs.sort((x, y) => {
            return x.order_index - y.order_index
          });
        return this.categoryData.inputs;
      },
    },
    methods: {
      handleEmittedData(data) {
        this.formData = {...this.formData, ...data};
        this.$emit('emit-data', this.formData)
      },
    },
  }
</script>

